import * as React from "react";
import styled from "styled-components";
import { DragDropContextProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

import { DropHandler } from "./CompanyValuesDropTarget";
import CompanyValuesDraggableFeature, {
  CompanyValuesDraggableFeaturePlaceholder,
  CompanyValuesDraggableFeatureModels,
} from "./CompanyValuesDraggableFeature";

type CompanyValueFeature = CompanyValuesDraggableFeatureModels["CompanyValueFeature"];

export interface CompanyValuesSorterModels {
  CompanyValueFeature: CompanyValueFeature;
}

interface Props {
  companyValueFeatures: CompanyValueFeature[];
  selectedFeatures: string[];
  onChange(features: string[]): void;
}

interface State {
  isDragging: boolean;
}

class CompanyValuesSorter extends React.Component<Props, State> {
  public state = {
    isDragging: false,
  };

  public onDragStart = () => {
    this.setState({
      isDragging: true,
    });
  };

  public onDragEnd = () => {
    this.setState({
      isDragging: false,
    });
  };

  public onDrop: DropHandler = (source, target) => {
    const { selectedFeatures, onChange } = this.props;
    const result = selectedFeatures.reduce(
      (acc, val) => {
        if (val === target.feature && target.position === "before") {
          acc.push(source.feature);
        }
        if (val !== source.feature) {
          acc.push(val);
        }
        if (val === target.feature && target.position === "after") {
          acc.push(source.feature);
        }
        return acc;
      },
      [] as string[]
    );
    onChange(result);
  };

  public onRemove = (feature: string) => {
    const { onChange, selectedFeatures } = this.props;
    onChange(selectedFeatures.filter(f => f !== feature));
  };

  public render() {
    const { selectedFeatures, companyValueFeatures } = this.props;
    const { isDragging } = this.state;
    return (
      <DragDropContextProvider backend={HTML5Backend}>
        <Wrapper>
          {Array.from({ length: 6 }).map((_, i) => {
            const selectedCompanyValueFeature = companyValueFeatures.find(f => f.feature === selectedFeatures[i]);
            if (selectedCompanyValueFeature) {
              return (
                <CompanyValuesDraggableFeature
                  key={selectedCompanyValueFeature.feature}
                  feature={selectedCompanyValueFeature}
                  index={i + 1}
                  isDragging={isDragging}
                  onDragStart={this.onDragStart}
                  onDragEnd={this.onDragEnd}
                  onDrop={this.onDrop}
                  onRemove={this.onRemove}
                />
              );
            }
            return <CompanyValuesDraggableFeaturePlaceholder key={i} />;
          })}
        </Wrapper>
      </DragDropContextProvider>
    );
  }
}

const Wrapper = styled.div`
  flex-grow: 1;
`;

export default CompanyValuesSorter;



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValuesSorter.tsx